import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeedService } from '../../Model/Feeds/feed.service';
import { SessionService } from '../../Util/Session/session.service';

@Component({
  selector: 'app-feed-list',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './feed-list.component.html',
  styleUrl: './feed-list.component.scss'
})
export class FeedListComponent {
  isDisabled: boolean = false;
  commentSectionVisible: boolean = false;
  date="02-12-2023";
  FeedDetails=[] as any
  feedItems = {
    ESS_PostMasterID: 0,
    Title:null as any,
    Description: null as any,
    Attachment:null as any,
    Tagged:null as any,
    LikeCount: 0,
    CommentCount:0,
    Date:null as any,
    CreatedTime: null as any,
    EmpMasterId :0
  }
  constructor(
    private post:FeedService,
    private session: SessionService,
  ){}
  ngOnInit(){
    this.GetFeedLoad();
  }

  toggleCommentSection(event:Event): void {
    event.preventDefault();
    this.commentSectionVisible = !this.commentSectionVisible;
  }
  GetFeedLoad(){
    this.post.PostLoad({SelectType:1,ESS_PostMasterID:0,EmpMasterId:this.session.GetUserDetails().UserId}).subscribe((response)=>{
     if(response.Table.toString !=null){
      this.FeedDetails=response.Table;
      // this.feedItems.Title=response.Table[0].Title;
      // this.feedItems.Description=response.Table[0].Description;
      // this.feedItems.LikeCount=response.Table[0].LikeCount;
      // this.feedItems.CommentCount=response.Table[0].CommentCount;
      // this.feedItems.Date=response.Table[0].Date;
      // this.feedItems.CreatedTime=response.Table[0].CreatedTime;
     }
      
    } , 
    (err) =>{}
    );
  }

}
